import { Component, EventEmitter, Output, OnInit, OnDestroy } from '@angular/core';
import { FirebaseOtpService } from '../../services/firebase-otp.service';
import { LoaderService } from 'src/app/util/loader.service';
import { ToastService } from 'src/app/util/toast.service';
import { CountryService } from 'src/app/services/country.service';

@Component({
  selector: 'app-phone-input',
  templateUrl: './phone-input.component.html',
  styleUrls: ['./phone-input.component.scss'],
})
export class PhoneInputComponent implements OnInit, OnDestroy {
  @Output() otpSent = new EventEmitter<any>();

  phoneNumber: string = '';
  name: string = '';

  selectedCountry = this.countryService.countries[0];

  constructor(
    private firebaseOtpService: FirebaseOtpService,
    private toast: ToastService, private loader: LoaderService,
    public countryService: CountryService
  ) { }

  async ngOnInit() {
    this.firebaseOtpService.clearRecaptcha();
    try {
      await this.firebaseOtpService.setupRecaptcha('recaptcha-container');
    } catch (error) {
      console.error('Error initializing reCAPTCHA:', error);
    }
  }

  ngOnDestroy() {
    this.firebaseOtpService.clearRecaptcha();
  }


  async sendOTP() {
    console.log('Sending OTP to phone number:', this.phoneNumber.length);
    if (!this.phoneNumber || this.phoneNumber.length < 7 || !this.name || this.name.length < 2) {
      this.toast.error('Please enter a valid mobile number and name.');
      return;
    }
    this.loader.show();
    try {
      const fullPhoneNumber = `${this.selectedCountry.code}${this.phoneNumber}`;
      await this.firebaseOtpService.sendOTP(fullPhoneNumber, this.selectedCountry.code);
      this.loader.hideForce();
      this.toast.success('OTP Sent! Please check your phone.');

      this.otpSent.emit({
        fullPhoneNumber: fullPhoneNumber,
        phoneNumber: this.phoneNumber,
        countryCode: this.selectedCountry.code,
        name: this.name
      });

    } catch (error: any) {
      this.loader.hideForce();
      console.error('Error sending OTP:', error);

      let errorMessage = 'Failed to send OTP. Please try again.';

      if (error.code === 'auth/too-many-requests') {
        errorMessage = 'Too many attempts. Please try again after some time (1-2 hours) or use a different phone number.';
      } else if (error.code === 'auth/invalid-phone-number') {
        errorMessage = 'Invalid phone number format.';
      } else if (error.code === 'auth/quota-exceeded') {
        errorMessage = 'SMS quota exceeded. Please contact support.';
      } else if (error.code === 'auth/captcha-check-failed') {
        errorMessage = 'Security check failed. Please try again.';
      } else if (error.code === 'auth/internal-error') {
        errorMessage = 'Something went wrong. Please try again.';
      } else if (error.code) {
        errorMessage = `Error: ${error.code}`;
      }

      this.toast.error(errorMessage);
    }
  }
  onPhoneNumberChange() {
    this.phoneNumber = this.phoneNumber.replace(/[^0-9]/g, '');
    if (this.phoneNumber.length > 15) { // Some countries have longer numbers
      this.phoneNumber = this.phoneNumber.substring(0, 15);
    }
  }
}